<template>
    <div class="consult-container">
        <ComDetail :detail="detail" :detailCols="detailCols" :onCancel="onCancel"></ComDetail>
        <div class="search-container">
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="服务商名称">
                    <el-input v-model="formInline.serverName" placeholder="请输入服务商名称"></el-input>
                </el-form-item>
                <el-form-item label="应用名称">
                    <el-input v-model="formInline.appName" placeholder="请输入应用名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table-container">
            <el-table v-loading="tableLoading" :data="tableData" :pagination="pagination" border style="width: 100%">
                <el-table-column prop="serverName" label="服务商" align="center">
                </el-table-column>
                <el-table-column prop="createDate" label="入驻时间" align="center" :formatter="dateFormat">
                </el-table-column>
                <el-table-column prop="appCount" align="center" label="上传应用数">
                </el-table-column>
                <el-table-column prop="status" align="center" label="服务状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status === 0">正常</span>
                        <span v-else-if="scope.row.status === 1">禁用</span>
                        <span v-else>未知状态</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="120">
                    <template slot-scope="scope">
                        <el-button class="mr-10" @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                        <el-popconfirm v-if="scope.row.status === 1" title="确定要启用吗？" @confirm="handleDelete(scope.row)">
                            <el-button slot="reference" type="text" size="small">启用</el-button>
                        </el-popconfirm>
                        <el-popconfirm v-if="scope.row.status === 0" title="确定要禁用吗？" @confirm="handleDelete(scope.row)">
                            <el-button slot="reference" type="text" size="small">禁用</el-button>
                        </el-popconfirm>

                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]"
                    :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { getServiceList, getServiceStopOrStart } from '@/api/SupermarketOperation'
import ComDetail from '@/components/common/comDetail.vue';
import moment from "moment";
import { appOnLineStatusDict, appTypeDict } from '@/data/constant'
export default {
    name: 'AdminStaticsService',
    components: {
        ComDetail
    },
    data() {
        return {
            tableLoading: false,
            detail: {
                visible: false,
                record: {},
                hasTable: true,
                tableTitle: '应用列表',
                tableData: [],
                tableCols: [
                    { label: '应用名称', prop: 'appName' },
                    { label: '应用类型', prop: 'appType', formatter: row => appTypeDict.find(it => it.value === row.appType).label },
                    { label: '应用状态', prop: 'isOn', formatter: row => appOnLineStatusDict[row.isOn] },
                ]
            },
            detailCols: [
                {
                    label: '服务商',
                    prop: 'serverName'
                },
                {
                    label: '入驻时间',
                    prop: 'createDate',
                    formatter: (row) => moment(row.createDate).format('YYYY-MM-DD HH:mm:ss'),
                },
                {
                    label: '上传应用数',
                    prop: 'appCount'
                },
                {
                    label: '服务状态',
                    prop: 'status',
                    formatter: row => row.status === 1 ? '禁用' : '正常'
                },
            ],
            formInline: {
                serverName: '',
                appName: '',
            },
            pagination: {
                currentPage: 1, // 当前页
                pageSize: 10, // 每页显示条数
                total: 0, // 总条数
                layout: 'total, prev, pager, next, jumper', // 分页布局
            },
            tableData: [],
        };
    },

    mounted() {
        this.loadData()
    },
    methods: {
        // 查看
        onCancel() {
            this.detail.visible = false
        },
        handleDelete(row) {
            getServiceStopOrStart({
                status: row.status === 1 ? 0 : 1,
                serverId: row.id
            }).then(() => {
                this.$message.success('提交成功')
                this.loadData()
            })
        },
        // 时间转换
        dateFormat(row) {
            return moment(row.createDate).format('YYYY-MM-DD HH:mm:ss');
        },
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        },
        handleClick(row) {
            this.detail.visible = true
            this.detail.record = row
            this.detail.tableData = row.appList
        },
        onSubmit() {
            this.loadData()
        },
        async loadData() {
            this.tableLoading = true
            const params = {}
            if (this.formInline.serverName) {
                params.serverName = this.formInline.serverName
            }
            await getServiceList({
                pageNo: this.pagination.currentPage - 1,
                pageSize: this.pagination.pageSize,
                ...params,
            }).then(res => {
                this.tableLoading = false
                this.tableData = res.data.content
                this.pagination.total = res.data.totalElements
            })
        }
    },
};
</script>
<style lang="scss" scoped>
.consult-container {
    background: #fff;
    padding: 24px 0;

    .search-container {
        padding: 0 16px;
        border-bottom: 1px solid #EBEEF5;
    }

    .table-container {
        padding: 16px;
    }

    .pagination-container {
        margin-top: 16px;
        text-align: right;
    }

    .mr-10 {
        margin-right: 10px;
    }

    .mx-10 {
        margin: 0 10px;
    }
}
</style>
<style lang="scss">
.el-popconfirm__main {
    margin: 10px 0;
}
</style>